module.exports = __webpack_public_path__ + "how_to_start.453a955.png";